import React from 'react';
import Image from '../../common/Image';
import { paintRBGImageDefaultProps, paintRBGImagePropTypes } from '../propTypes';

const PaintRGBImage = ({ asset, alt }) => {
  if (!asset) return null;
  const rgb = asset?.rgb;
  return (
    <div
      className="w-full h-auto aspect-square max-w-full flex items-end"
      style={{
        backgroundColor: `rgb(${rgb?.red},${rgb?.green},${rgb?.blue})`
      }}
    >
      <Image
        alt={alt}
        src={asset?.brandLogo}
      />
    </div>
  );
};

PaintRGBImage.propTypes = paintRBGImagePropTypes;
PaintRGBImage.defaultProps = paintRBGImageDefaultProps;

export default PaintRGBImage;
